import { useContextSelector } from 'use-context-selector'
import { AppCurrencyContext, AppMarketContext } from '../../../../providers'


export default function useAppMarketSelector() {

    const market = useContextSelector(AppMarketContext, ({state}) => state.market)
    const setMarket = useContextSelector(AppMarketContext, ({updateState}) => updateState)

    const setCurrency = useContextSelector(AppCurrencyContext, ({replaceState}) => replaceState)


    return {
        market,
        setMarket,
        setCurrency,
    }
}